import React from "react";
import {
	RetryButton,
	StateDescription,
	StateTitle,
	StateWrapper,
} from "./elements";

const AccountInsightsErrorState = ({ translate, onRetry }) => (
	<StateWrapper>
		<StateTitle>{translate("accountInsights.error.title")}</StateTitle>
		<StateDescription>{translate("accountInsights.error.description")}</StateDescription>
		<RetryButton
			type="button"
			onClick={onRetry}>
			{translate("accountInsights.error.retry")}
		</RetryButton>
	</StateWrapper>
);

export default AccountInsightsErrorState;
